/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import './GovBrTable.css';

export function TableHeader({ columns, checkbox, teste }) {
  const [value, setValue] = useState(false);
  return (
    <thead>
      <tr>
        {checkbox && (
          <>
            <th className="column-checkbox pl-1" scope="col">
              <div className="br-checkbox hidden-label">
                <input
                  id="select-all"
                  value={value}
                  checked={value}
                  onChange={(e) => {
                    teste(e);
                    setValue((prev) => !prev);
                  }}
                  name="select-all"
                  type="checkbox"
                  aria-label="Selecionar tudo"
                />
                <label htmlFor="select-all">Selecionar todas as linhas</label>
              </div>
            </th>
          </>
        )}

        {columns.map((el) => (
          <th scope="col">
            <div className="personCol">
              {el}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
}
